import {CONTENT_TYPE, ImageComponent, YouTubeComponent, useMediaQuery } from "@educaplay/core";
import classes from "./DialogClueContent.module.scss"
import clsx from "clsx";
import { AudioComponentControl } from "@educaplay/core/components/AudioComponentControl";

function DialogClueContent(props) {

    const { mediaType, media, title, explanation } = props;

    const isDesktopDisposition = useMediaQuery("(orientation: landscape)");

    const multimedia = <div className={clsx(media && classes.multimediacontainer, (!isDesktopDisposition && media) && classes.positionleft)}>
        {mediaType === CONTENT_TYPE.IMAGE && (
            <div className={classes.containerImage}>
                <ImageComponent source={media} className={classes.image} />
            </div>
        )}
        {mediaType === CONTENT_TYPE.AUDIO && (
            <div className={classes.containerAudio}>
                <AudioComponentControl source={media} className={classes.audio} autoplay/>
            </div>
        )}
        {mediaType === CONTENT_TYPE.YOUTUBE && (
            <YouTubeComponent url={media} />
        )}
    </div>
    
    return (
        <div className={classes.infoContainer}>
            <div className={clsx(classes.disposition, !media && classes.dispositionWithoutImage)}>
                <div className={classes.titleanddescriptioncontainer}>
                    <div className={classes.titleContainer}>
                        {title}
                    </div>
                </div>
            </div>
            <div className={clsx(classes.explanationContainer, classes.scrollbar)}>
                {multimedia}
                <p>{explanation}</p>
            </div>

        </div>
    )
}

export default DialogClueContent;